import { addZero } from "./addZero";

export function nHoursFromNow(n) {
    const d = new Date();
    d.setHours(d.getHours() + n);
	const year = d.getFullYear();
	const month = addZero(d.getMonth() + 1);
	let date = addZero(d.getDate());
	const hours = addZero(d.getHours());
	const minutes = addZero(d.getMinutes());
	const seconds = addZero(d.getSeconds());

	date = `${year}${month}${date}`;
	const time = `${hours}:${minutes}:${seconds}`;

	return `${date} ${time}`;
}
